// Ground Control Design System
// Green internal app / Purple external invoices

export const COLORS = {
  bg: '#0a0f0a',
  bgCard: '#111a11',
  bgCardHover: '#162016',
  bgInput: '#0d140d',
  border: '#1e3a1e',
  borderFocus: '#4ade80',
  green: '#4ade80',
  greenDim: '#22c55e',
  greenDark: '#166534',
  greenGlow: 'rgba(74, 222, 128, 0.15)',
  greenGlowStrong: 'rgba(74, 222, 128, 0.3)',
  gold: '#7c3aed',
  goldDim: '#6d28d9',
  text: '#e8f5e8',
  textDim: '#8fb08f',
  textMuted: '#5a7a5a',
  danger: '#ef4444',
  dangerDim: '#991b1b',
  warning: '#7c3aed',
  purple: '#7c3aed',
  purpleDim: '#6d28d9',
  white: '#ffffff',
};

export const TAX_CATEGORIES = [
  'Construction Materials',
  'Insurance/Bond',
  'Vehicle/Fuel',
  'Advertising',
  'Communications',
  'Meals (50%)',
  'Meals (100%)',
  'Office Expense',
  'Home Office',
  'Legal and Professional Fees',
  'Business Travel',
  'Licensing',
  'Taxes',
  'Bank Fee',
  'Subcontractor',
];

export const JOB_STATUSES = ['active', 'completed', 'archived'];

// Invoice number format: YYYY-### 
export const generateInvoiceNumber = (year, existingCount) => {
  const num = String(existingCount + 1).padStart(3, '0');
  return `${year}-${num}`;
};
